module.exports = "https://static.wmbcdn.com/uniweb/images/bbb8e02ca0a48dfa59eba96bca557b4e.svg";